import FormControl from "@mui/material/FormControl"
import FormControlLabel from "@mui/material/FormControlLabel"
import FormLabel from "@mui/material/FormLabel"
import Radio from "@mui/material/Radio"
import { default as RG } from "@mui/material/RadioGroup"
import React from "react"

export interface RadioGroupProps {
    name?: string
    value: string
    values: string[]
    onChange: (event: React.ChangeEvent<HTMLInputElement>, value: string) => void
}

export default function RadioGroup({ name, value, values, onChange }: RadioGroupProps) {
    return (
        <FormControl component="fieldset">
            <FormLabel component="legend">{name}</FormLabel>
            <RG row aria-label={name} value={value} onChange={onChange}>
                {values && values.map((v, index) => <FormControlLabel key={index} value={v} control={<Radio color="primary" />} label={v} />)}
            </RG>
        </FormControl>
    )
}
